import { Button, Card, Spinner } from "@heroui/react";
import { env } from "@/src/common/constants/env";
import { useOAuthConsent } from "@/src/oauth/hooks/use-oauth-consent";

const hostOf = (uri: string | null): string | null => {
	if (!uri) {
		return null;
	}
	try {
		return new URL(uri).host;
	} catch {
		return null;
	}
};

const OAuthAuthorizePage: React.FC = () => {
	const { client, clientId, redirectUri, isValidRequest, isLoading, isApproving, error, approve, deny } = useOAuthConsent();
	const clientLabel = client?.clientName ?? hostOf(redirectUri) ?? clientId ?? "Client inconnu";

	return (
		<main className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-background px-4 py-8">
			<div className="flex flex-col items-center gap-1">
				<span className="font-bold text-2xl text-foreground tracking-tight">{env.APP_NAME}</span>
				<span className="text-muted text-sm">Storylines Studio — autorisation MCP</span>
			</div>

			<Card className="w-full max-w-md bg-surface">
				<Card.Header>
					<Card.Title>Demande d'accès</Card.Title>
					<Card.Description>
						<span className="font-semibold text-foreground">{clientLabel}</span> demande l'accès au serveur MCP Storylines Studio avec votre
						compte admin.
					</Card.Description>
				</Card.Header>
				<Card.Content>
					{error ? <p className="mb-4 rounded-lg border border-border-soft bg-glass p-3 text-center text-danger text-sm">{error}</p> : null}

					{isLoading ? (
						<div className="flex justify-center py-8">
							<Spinner size="lg" />
						</div>
					) : (
						<div className="flex flex-col gap-4">
							<ul className="flex flex-col gap-2 rounded-xl border border-border-soft bg-glass p-4 text-muted text-sm">
								<li>Lire et concevoir les séries, plans d'épisodes et golden assets</li>
								<li>Piloter le pipeline de production (les générations payantes exigeront votre confirmation)</li>
								<li>Publier ou dépublier des épisodes après votre accord</li>
							</ul>
							{redirectUri ? (
								<p className="text-muted text-xs">Redirection après autorisation : {hostOf(redirectUri) ?? redirectUri}</p>
							) : null}
							<div className="flex gap-3">
								<Button className="flex-1" isDisabled={!isValidRequest || isApproving} onPress={() => void approve()}>
									{isApproving ? "Autorisation…" : "Autoriser"}
								</Button>
								<Button className="flex-1" variant="secondary" isDisabled={!redirectUri || isApproving} onPress={deny}>
									Refuser
								</Button>
							</div>
						</div>
					)}
				</Card.Content>
			</Card>
		</main>
	);
};

export default OAuthAuthorizePage;
